export default {
    namespaced: true,
    state: {
        showOrHide:false,
        title:"",
        checkList:{},
        show:false,
        val:"",
        active: 0
    },
    // getters:{},
    mutations: {
        setShowOrHide(state,showOrHide){
            state.showOrHide=showOrHide
        }, 
        setShow(state,show){
            state.show=show
        },
        setTitle(state,title){
            state.title=title
        },
        setCheckList(state,checkList){
            state.checkList=checkList
        }, 
        setVal(state,val){
            state.val=val
        },
        setActive(state,active){
            state.active=active
        } 
    },
    actions: {
        actionSetShowOrHide({
            commit
        }, showOrHide) {
            commit('setShowOrHide', showOrHide)
        },
        actionSetShow({
            commit
        }, show) {
            commit('setShow', show)
        },
        actionSetTitle({
            commit
        }, title) {
            commit('setTitle', title)
        },
        actionSetCheckList({
            commit
        }, checkList) {
            commit('setCheckList', checkList)
        },
        actionSetVal({
            commit
        }, val) {
            commit('setVal', val)
        },
        actionSetActive({
            commit
        }, active) {
            commit('setActive', active)
        },
    }
}
